import { render, staticRenderFns } from "./AdminTwilio.vue?vue&type=template&id=3c7f5bea&scoped=true&"
import script from "./AdminTwilio.vue?vue&type=script&lang=js&"
export * from "./AdminTwilio.vue?vue&type=script&lang=js&"
import style0 from "./AdminTwilio.vue?vue&type=style&index=0&id=3c7f5bea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7f5bea",
  null
  
)

export default component.exports